import data from './data'
import components from './components'

export default {
  components,
  data,
  /* route API for professional specialiteis */
  resourcePath: '/v1/professional/profile/specialities'
}



// WEBPACK FOOTER //
// ./src/app/employee/record/specialities/resources/index.js